import {Injectable} from '@angular/core';
import { PermissionsEnum } from '@shared/enum/permissions.enum';
/* eslint-disable */
export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  permission?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'panel',
    title: 'Panel',
    type: 'item',
    url: '/panel',
    icon: 'assets/new-icons/dashboards.svg',
    classes: 'nav-item',
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'item',
    permission: PermissionsEnum.DASHBOARD_ACCESS,
    url: '/dashboard',
    icon: 'assets/new-icons/menu-dashboard.svg',
    classes: 'nav-item',
  },
  {
    id: 'profile',
    title: 'Profile',
    type: 'item',
    url: '/profile',
    icon: 'assets/new-icons/person.png',
    classes: 'nav-item',
  },
  {
    id: 'restaurant',
    title: 'Restaurants',
    type: 'item',
    permission: PermissionsEnum.INDEX_RESTAURANT,
    url: '/restaurant',
    icon: 'assets/new-icons/restaurant2.svg',
    classes: 'nav-item',
  },
  {
    id: 'staff',
    title: 'Staff',
    type: 'item',
    permission: PermissionsEnum.INDEX_STAFF,
    url: '/staff',
    icon: 'assets/new-icons/staff.svg',
    classes: 'nav-item',
  },
  {
    id: 'users',
    title: 'Users',
    type: 'item',
    permission: PermissionsEnum.INDEX_STAFF,
    url: '/users',
    icon: 'assets/new-icons/staff.svg',
    classes: 'nav-item',
  },
  {
    id: 'Orders',
    title: 'Orders',
    type: 'item',
    permission: PermissionsEnum.INDEX_ORDER,
    url: '/orders',
    icon: 'assets/new-icons/order.svg',
    classes: 'nav-item',
  },
  {
    id: 'menu',
    title: 'Menus',
    type: 'item',
    permission: PermissionsEnum.INDEX_MENU,
    url: '/menus',
    icon: 'assets/new-icons/menu.svg',
    classes: 'nav-item',
  },
  {
    id: 'table',
    title: 'Tables',
    type: 'item',
    permission: PermissionsEnum.INDEX_RESTAURANT_TABLE,
    url: '/tables',
    icon: 'assets/new-icons/table.svg',
    classes: 'nav-item',
  },
  {
    id: 'ai',
    title: 'AI Features',
    type: 'item',
    permission: PermissionsEnum.INDEX_AI_CONTENT,
    url: '/ai',
    icon: 'assets/new-icons/menu.svg',
    classes: 'nav-item',
  },
];

@Injectable()
export class NavigationItem {
  get() {
    return NavigationItems;
  }
}
